import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function ESFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 24">
        <mask
          id="mantine-dkt4s3v29"
          style={{ maskType: 'alpha' }}
          width="32"
          height="24"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M0 0h32v24H0z" />
        </mask>
        <g mask="url(#mantine-dkt4s3v29)">
          <path fill="#FFB400" fillRule="evenodd" d="M0 0v24h32V0H0z" clipRule="evenodd" />
          <mask
            id="mantine-19kzshcdd"
            style={{ maskType: 'alpha' }}
            width="32"
            height="24"
            x="0"
            y="0"
            maskUnits="userSpaceOnUse"
          >
            <path fill="#fff" fillRule="evenodd" d="M0 0v24h32V0H0z" clipRule="evenodd" />
          </mask>
          <g mask="url(#mantine-19kzshcdd)">
            <path
              fill="#C51918"
              fillRule="evenodd"
              d="M0 0v6h32V0H0zm0 18v6h32v-6H0z"
              clipRule="evenodd"
            />
            <path fill="#F1F9FF" d="M5.008 10.272h1.12v5.824h-1.12z" />
            <path
              fill="#C88A02"
              fillRule="evenodd"
              d="M6.576 9.264H4.56v.56h.336v.448H6.24v-.448h.336v-.56zm-.336 7.168h.336v.56H4.56v-.56h.336v-.448H6.24v.448z"
              clipRule="evenodd"
            />
            <path
              fill="#AD1619"
              fillRule="evenodd"
              d="M5.568 9.376c.244 0 .269-.092.412-.229.112-.106.372-.238.372-.387 0-.34-.351-.616-.784-.616-.433 0-.784.276-.784.616 0 .166.18.276.315.387.142.117.247.229.47.229z"
              clipRule="evenodd"
            />
            <path
              fill="#005BBF"
              fillRule="evenodd"
              d="M4.56 16.992h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112v-.896z"
              clipRule="evenodd"
            />
            <mask
              id="mantine-foo9lrvab"
              style={{ maskType: 'alpha' }}
              width="3"
              height="2"
              x="4"
              y="16"
              maskUnits="userSpaceOnUse"
            >
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M4.56 16.992h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112v-.896z"
                clipRule="evenodd"
              />
            </mask>
            <g fill="#fff" mask="url(#mantine-foo9lrvab)">
              <path d="M4.542 17.712l-.044-.107a1.33 1.33 0 01.546-.122c.118 0 .18.017.284.063a.49.49 0 00.24.054.49.49 0 00.24-.054.593.593 0 01.285-.063c.182 0 .364.04.546.122l-.044.107a1.227 1.227 0 00-.502-.112.49.49 0 00-.24.054.593.593 0 01-.285.063.593.593 0 01-.284-.063.49.49 0 00-.24-.054c-.167 0-.334.037-.502.112zm0-.336l-.044-.107a1.33 1.33 0 01.546-.122c.118 0 .18.017.284.063a.49.49 0 00.24.054.49.49 0 00.24-.054.593.593 0 01.285-.063c.182 0 .364.04.546.122l-.044.107a1.227 1.227 0 00-.502-.112.49.49 0 00-.24.054.593.593 0 01-.285.063.593.593 0 01-.284-.063.49.49 0 00-.24-.054c-.167 0-.334.037-.502.112z" />
            </g>
            <path fill="#F1F9FF" d="M15.984 10.272h1.12v5.824h-1.12z" />
            <path
              fill="#C88A02"
              fillRule="evenodd"
              d="M17.552 9.264h-2.016v.56h.336v.448h1.344v-.448h.336v-.56zm-.336 7.168h.336v.56h-2.016v-.56h.336v-.448h1.344v.448z"
              clipRule="evenodd"
            />
            <path
              fill="#AD1619"
              fillRule="evenodd"
              d="M16.544 9.376c.244 0 .268-.092.412-.229.112-.106.372-.238.372-.387 0-.34-.351-.616-.784-.616-.433 0-.784.276-.784.616 0 .166.18.276.315.387.142.117.247.229.469.229z"
              clipRule="evenodd"
            />
            <path
              fill="#005BBF"
              fillRule="evenodd"
              d="M15.536 16.992h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112v-.896z"
              clipRule="evenodd"
            />
            <mask
              id="mantine-dxx09qopi"
              style={{ maskType: 'alpha' }}
              width="3"
              height="2"
              x="15"
              y="16"
              maskUnits="userSpaceOnUse"
            >
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M15.536 16.992h2.016v.896s-.252-.112-.504-.112-.504.112-.504.112-.252-.112-.504-.112-.504.112-.504.112v-.896z"
                clipRule="evenodd"
              />
            </mask>
            <g fill="#fff" mask="url(#mantine-dxx09qopi)">
              <path d="M15.518 17.712l-.044-.107a1.33 1.33 0 01.546-.122c.118 0 .18.017.284.063a.49.49 0 00.24.054.49.49 0 00.24-.054.593.593 0 01.285-.063c.182 0 .364.04.546.122l-.044.107a1.227 1.227 0 00-.502-.112.49.49 0 00-.24.054.593.593 0 01-.285.063.593.593 0 01-.284-.063.49.49 0 00-.24-.054c-.167 0-.334.037-.502.112zm0-.336l-.044-.107a1.33 1.33 0 01.546-.122c.118 0 .18.017.284.063a.49.49 0 00.24.054.49.49 0 00.24-.054.593.593 0 01.285-.063c.182 0 .364.04.546.122l-.044.107a1.227 1.227 0 00-.502-.112.49.49 0 00-.24.054.593.593 0 01-.285.063.593.593 0 01-.284-.063.49.49 0 00-.24-.054c-.167 0-.334.037-.502.112z" />
            </g>
            <path
              fill="#AD1619"
              fillRule="evenodd"
              d="M4.988 15.68c.202-.245.315-.468.315-.704a.632.632 0 00-.122-.383l.013-.006c-.001 0 .221-.097.299-.134a2.56 2.56 0 00.395-.232c.079-.058.185-.12.346-.207l.152-.08.041-.023c.078-.041.137-.073.191-.105.17-.098.281-.18.367-.288a.535.535 0 00-.124-.798c-.139-.095-.326-.149-.601-.192l-.057-.008a151.658 151.658 0 01-.69-.11c.688-.115 1.671-.073 2.104.15l.41-.796c-.88-.455-2.889-.409-3.639.108-.55.379-.476.952.096 1.198.24.103.551.172 1.128.264a2.867 2.867 0 00-.251.162 1.597 1.597 0 01-.255.15l-.25.111-.033.014c-.466.212-.693.505-.625 1.035l.037.287.065.02.688.567zm-.576-.74l-.002.003.001-.002v-.002zm12.294.036c0 .236.113.46.315.704l.688-.567.065-.02.037-.287c.067-.53-.159-.823-.625-1.035l-.032-.014c-.064-.028-.204-.09-.25-.112a1.596 1.596 0 01-.256-.149 2.868 2.868 0 00-.252-.162c.577-.092.89-.16 1.128-.264.573-.246.647-.82.096-1.198-.75-.517-2.758-.563-3.64-.108l.412.796c.433-.223 1.416-.265 2.104-.15a138.39 138.39 0 01-.69.11l-.057.008c-.275.043-.463.098-.601.192a.535.535 0 00-.124.798c.086.109.198.19.367.288.054.032.112.064.19.105l.042.022.152.08c.161.088.267.15.346.208.124.09.25.163.395.232.078.037.3.134.299.134l.013.006a.633.633 0 00-.122.383z"
              clipRule="evenodd"
            />
            <path
              fill="#F1F9FF"
              d="M5.923 12.4l.331.068v.493c-.352.281-1.246.755-1.246.755V12.4h.915zm10.392 0l-.331.068v.493c.352.281 1.246.755 1.246.755V12.4h-.915z"
            />
            <path
              fill="#AD1619"
              fillRule="evenodd"
              d="M14.776 7.206v-.164c-.576-.413-1.18-.62-1.81-.62a3.613 3.613 0 00-1.835-.312v-.003c-.93-.09-1.869.315-1.869.315-.946 0-1.81.62-1.81.62v.164l1.13 1.134s.318 1.092 2.545.836v.003s1.474-.04 1.577-.075c.042-.014.084-.026.128-.039.289-.084.618-.18.814-.725l1.13-1.134zm-3.65-1.045c-.032.377-.215 2.654 0 3.007V6.161z"
              clipRule="evenodd"
            />
            <path
              fill="#C88A02"
              fillRule="evenodd"
              d="M8.314 8.15v-.004l-.794-.748.077-.081.745.701.02-.087a.95.95 0 00.262.03V7.81l.166.09c.081.044.198.056.35.03.114-.018.19-.149.214-.427l.05-.563.169.54c.076.243.192.35.358.35.161 0 .226-.058.233-.208l.02-.423.192.378c.069.136.164.198.3.198.193 0 .322-.161.322-.414h.228c0 .253.129.414.322.414.136 0 .23-.062.3-.198l.191-.378.02.423c.008.15.073.209.234.209.166 0 .282-.108.358-.352l.168-.54.05.564c.025.278.101.41.214.428.153.025.27.013.351-.031l.165-.09v.152a.95.95 0 00.264-.03l.035.163.825-.777.077.081-1.027.967c-.15.276-.226.458-.226.534 0 .115-.3.184-.886.254-.46.055-1.001.092-1.445.098h-.112a14.438 14.438 0 01-1.445-.098c-.586-.07-.887-.139-.887-.254a.236.236 0 00-.008-.054.881.881 0 01-.128-.31 5.667 5.667 0 00-.089-.17L8.32 8.15l-.005-.001zm5.505.018c-.183.032-.316.029-.386-.028a.879.879 0 01-.386.01c-.157-.025-.267-.13-.333-.303a.513.513 0 01-.325.2c.717.1 1.219.244 1.219.244s-.012.106-.042.23c.031-.065.07-.137.113-.217l.01-.014.13-.122zm-1.768-.164a.359.359 0 01-.148-.134.5.5 0 01-.182.103c.113.008.223.019.33.03zm-.725-.053a.513.513 0 01-.214-.188.513.513 0 01-.212.187l.154-.003h.09c.061 0 .122.002.182.004zm-2.704.33l-.104-.097c.125.012.218 0 .273-.044.11.032.239.035.386.01.157-.025.267-.13.332-.303a.514.514 0 00.314.197c-.618.087-1.079.205-1.2.238zm1.876-.31A9.62 9.62 0 0010.18 8a.36.36 0 00.14-.13c.053.046.112.08.178.101zm2.755.93c.079.037.141 0 .191-.07a.364.364 0 00-.008.053.198.198 0 01-.03.015 1.083 1.083 0 01-.166.048 6.13 6.13 0 01-.592.095c-.475.057-1.04.095-1.488.097a14.191 14.191 0 01-1.488-.097 6.131 6.131 0 01-.592-.095 1.26 1.26 0 01-.147-.04.179.179 0 00.012-.006c.245-.114 1.863-.222 2.154-.24.291.018 1.91.126 2.154.24zm.308-.02v.001-.001z"
              clipRule="evenodd"
            />
            <path
              fill="#005BBF"
              fillRule="evenodd"
              d="M11.112 5.347a.336.336 0 100-.672.336.336 0 000 .672z"
              clipRule="evenodd"
            />
            <path
              fill="#C88A02"
              fillRule="evenodd"
              d="M10.894 6.997a.44.44 0 00.032.102.425.425 0 00-.15-.027c-.155 0-.28.076-.28.168 0 .093.125.168.28.168.155 0 .28-.075.28-.168 0 .093.126.168.28.168.155 0 .28-.075.28-.168 0-.092-.125-.168-.28-.168a.445.445 0 00-.11.014.424.424 0 00-.002-.153c-.03-.152-.128-.26-.219-.243-.09.018-.14.155-.111.307zm.162.243v-.005.005zm-1.81-.03a.446.446 0 01-.032-.101c-.03-.152.02-.29.111-.307.091-.018.19.09.219.243.01.054.01.107.002.153a.445.445 0 01.11-.014c.155 0 .28.076.28.168 0 .093-.125.168-.28.168-.155 0-.28-.075-.28-.168v-.005.005c0 .093-.125.168-.28.168-.155 0-.28-.075-.28-.168 0-.092.125-.168.28-.168.055 0 .107.01.15.027zm3.508.103c-.013.092-.147.149-.3.127-.154-.021-.267-.113-.255-.205.013-.092.148-.149.301-.127a.424.424 0 01.145.046.44.44 0 01-.018-.105c-.008-.154.06-.283.153-.288.093-.005.175.116.183.27a.425.425 0 01-.019.153.445.445 0 01.11.002c.154.021.268.113.255.205-.013.092-.148.149-.301.127-.153-.021-.267-.113-.254-.205zm0 0v-.005.005zm1.066.444c.137.073.283.065.326-.017l.003-.004a.11.11 0 00.047.03c.09.027.198-.07.243-.219.045-.148.01-.29-.079-.317-.089-.027-.197.071-.242.219a.447.447 0 00-.02.105.424.424 0 00-.12-.093c-.136-.073-.282-.065-.326.016-.043.082.032.208.168.28zm-5.495.035c-.137.072-.283.065-.326-.017a.103.103 0 01-.002-.005.11.11 0 01-.048.03c-.089.027-.197-.07-.243-.218-.045-.148-.01-.29.08-.317.088-.027.197.07.242.218a.446.446 0 01.019.105.424.424 0 01.12-.093c.137-.073.283-.065.326.017.044.082-.032.207-.168.28zm2.662-3.715h.233v.147h.153v.233h-.153v.467h.153v.233h-.541v-.233h.155v-.467h-.155v-.233h.155v-.147z"
              clipRule="evenodd"
            />
            <path fill="#C88A02" d="M10.944 5.344h.448V6.8h-.448z" />
            <path
              fill="#fff"
              d="M9.14 5.588V5.7c-.993-.018-1.563.127-1.708.416-.15.299-.121.662.088 1.093l-.1.05c-.224-.461-.255-.86-.088-1.193.172-.343.775-.496 1.81-.478z"
            />
            <path
              fill="#fff"
              d="M9.333 6.581l-.058.096c-.216-.129-.324-.35-.324-.653 0-.437.225-.692.722-.868.318-.111.751-.066 1.302.134l-.038.105c-.529-.191-.938-.235-1.227-.133-.456.16-.647.378-.647.762 0 .266.09.45.27.557z"
            />
            <path
              fill="#C88A02"
              d="M7.66 7.037l-.211.075c-.22-.625-.157-1.049.218-1.232.33-.16.811-.226 1.446-.2l-.01.223c-.6-.024-1.047.037-1.338.179-.246.12-.291.425-.105.955z"
            />
            <path
              fill="#C88A02"
              d="M10.13 5.439c-.513 0-.723.124-.843.493-.077.234-.003.435.238.622l-.137.177c-.312-.242-.422-.539-.314-.869.153-.47.453-.647 1.055-.647.395 0 .702.103.916.314l.034.033v1.08h-.224v-.984c-.167-.145-.408-.22-.726-.22z"
            />
            <path
              fill="#fff"
              d="M13.05 5.7l.001.112c.993-.018 1.563.127 1.707.416.15.299.122.662-.087 1.093l.1.05c.224-.461.254-.86.088-1.193-.172-.343-.775-.496-1.81-.478z"
            />
            <path
              fill="#fff"
              d="M12.698 6.604l.058.096c.216-.129.324-.35.324-.653 0-.436-.225-.692-.722-.867-.317-.112-.75-.066-1.302.133l.038.106c.53-.192.939-.235 1.227-.134.456.16.647.379.647.762 0 .267-.09.45-.27.557z"
            />
            <path
              fill="#C88A02"
              d="M14.6 7.15l.21.074c.22-.625.157-1.049-.217-1.232-.33-.16-.812-.226-1.446-.2l.009.223c.6-.024 1.048.037 1.338.179.247.12.292.425.105.955z"
            />
            <path
              fill="#C88A02"
              d="M12.117 5.456c.513 0 .723.125.843.493.077.235.002.435-.239.622l.138.177c.312-.242.422-.539.314-.868-.153-.47-.454-.648-1.056-.648-.394 0-.702.104-.916.315l-.033.033v1.08h.224v-.985c.167-.145.407-.219.725-.219z"
            />
            <path
              fill="#E1E5E8"
              fillRule="evenodd"
              d="M7.472 9.264h7.28v6.54S14.212 18 11.112 18s-3.64-2.253-3.64-2.253V9.264z"
              clipRule="evenodd"
              opacity=".3"
            />
            <mask
              id="mantine-iogdnihun"
              style={{ maskType: 'alpha' }}
              width="8"
              height="9"
              x="7"
              y="9"
              maskUnits="userSpaceOnUse"
            >
              <path
                fill="#fff"
                fillRule="evenodd"
                d="M7.472 9.264h7.28v6.54S14.212 18 11.112 18s-3.64-2.253-3.64-2.253V9.264z"
                clipRule="evenodd"
              />
            </mask>
            <g mask="url(#mantine-iogdnihun)">
              <path fill="#FFC034" d="M7.472 13.296h3.696v4.368H7.472z" />
              <path
                fill="#AD1619"
                d="M7.92 13.52h.448v4.144H7.92zm1.568 0h.448v4.144h-.448zm-.784 0h.448v4.144h-.448zm1.568 0h.448v4.144h-.448zm-2.8-4.368h3.696v4.256H7.472z"
              />
              <path fill="#AD1619" d="M11.056 13.184h3.696v4.256h-3.696z" />
              <path fill="#F1F9FF" d="M11.056 9.264h3.92v4.144h-3.92z" />
              <path
                fill="#C88A02"
                fillRule="evenodd"
                d="M9.04 9.6h.336v.93H9.6v-.465h.336v.464h.336v.58h-.336v1.046h.336v.581H8.256v-.58h.336V11.11h-.336v-.58h.224v-.465h.336v.464h.224V9.6z"
                clipRule="evenodd"
              />
              <path fill="#C88A02" d="M12.979 9.795l.23-.245.48.45-.229.245-.481-.45z" />
              <path
                fill="#FFC034"
                fillRule="evenodd"
                d="M14.36 16.14v-2.452h-2.8v2.432l.005.018c.141.604.624.91 1.395.91.77 0 1.253-.298 1.395-.888l.005-.02zm-1.4.572c-.619 0-.957-.208-1.064-.632v-2.056h2.128v2.075c-.107.41-.445.613-1.064.613z"
                clipRule="evenodd"
              />
              <path
                fill="#FFC034"
                fillRule="evenodd"
                d="M13.076 13.893h-.234v1.112l-.92-1-.164.15.831.905h-.753v.336h.772l-.85.925.165.152.92-1v1.299h.233v-1.183l.812.884.165-.152-.85-.925h.949v-.336h-.931l.832-.904-.165-.152-.812.884v-.995z"
                clipRule="evenodd"
              />
              <path
                fill="#F1F9FF"
                fillRule="evenodd"
                d="M13.483 17.443s-2.372.186-2.372-1.344c0 0-.023 1.344-2.5 1.344v1.207h4.872v-1.207z"
                clipRule="evenodd"
              />
              <path
                fill="#005BBF"
                fillRule="evenodd"
                stroke="#AD1619"
                strokeWidth="1.167"
                d="M11.112 14.192c.464 0 .84-.401.84-.896s-.376-.896-.84-.896c-.464 0-.84.401-.84.896s.376.896.84.896z"
                clipRule="evenodd"
              />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}
